import { createIdStatusHelpers } from "~/utils/statusLookup";
const helpers = createIdStatusHelpers({
    classPrefix: "transmission-live-status",
    byId: {
        "1": { label: "Live", slug: "live" },
        "0": { label: "Not Live", slug: "not-live" },
    },
});
export function getTransmissionLiveStatusMeta(value) {
    return helpers.getMeta(value);
}
export function getTransmissionLiveStatusOption(flag) {
    const id = String(flag.id);
    const meta = helpers.getMeta(id);
    return {
        id,
        name: meta.label || String(flag.name || ""),
        optionClass: meta.className,
    };
}
